export default defineNuxtRouteMiddleware((to, from) => {
    const isMaintenance = useRuntimeConfig().public.maintenance;

    const allowedRoutes = [
        '/maintenance',
    ];

    if (isMaintenance && !allowedRoutes.includes(to.path)) {
        return navigateTo('/maintenance');
    } else if (!isMaintenance && to.path === '/maintenance') {
        return navigateTo('/'); 
    }
})
